import { useEffect, useState } from 'react'
import useSetInitTransaction from './hooks/useSetInitTransaction'
import HandIcon from 'assets/images/easyPay/init.svg'
import Footer from './footer'
import { useLocation } from 'react-router-dom'
import DotsLoading from 'components/loadings/dotsLoading'
import classNames from 'classnames'
import style from './init.module.scss'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import Switch from 'react-switch'
import {
    getActiveGateways,
    useActiveGatewayCode,
} from 'utilities/hooks/useIsDefaultGateway'

export default function InitTransaction() {
    const [fuckingAmount, setFuckingAmount] = useState<number>(0)
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data, isLoading } = useSetInitTransaction(profile.id)
    const { state } = useLocation()
    const { data: walletData } = useGetInitPaymentOs(profile?.id)
    const [selectedCode, setSelectedCode] = useState<string | null>(null)

    const activeGateways = getActiveGateways(data)
    useActiveGatewayCode(data, setSelectedCode)

    useEffect(() => {
        if (state && walletData) {
            if (isWallet) {
                if (
                    Number(walletData.wallet_balance) <
                    Number(state?.commission + state.total)
                ) {
                    setFuckingAmount(
                        Number(state?.commission + state.total) -
                            Number(walletData.wallet_balance)
                    )
                }
                if (
                    Number(walletData.wallet_balance) >=
                    Number(state?.commission + state.total)
                ) {
                    setFuckingAmount(0)
                }
            } else {
                setFuckingAmount(Number(state?.commission + state.total))
            }
        }
    }, [isWallet, walletData, state])
    return (
        <div className="">
            {data && state && walletData && !isLoading ? (
                <>
                    <div className=" relative">
                        <img
                            src={HandIcon}
                            alt="hand"
                            className=" mx-auto absolute -top-16 z-50 right-32"
                        />

                        <div className={style['StyledReceipt']}>
                            <div className=" flex justify-between mt-4">
                                <p className="">مبلغ:</p>
                                <p>{state?.total.toLocaleString()} تومان</p>
                            </div>
                            <div className=" flex justify-between mt-4">
                                <p className="">هزینه اشتراک:</p>
                                <p>
                                    {state?.commission.toLocaleString()} تومان
                                </p>
                            </div>
                            <div className=" flex justify-between mt-4">
                                <p className=""> بابت:</p>
                                <p>پرداخت آسان</p>
                            </div>
                            {walletData &&
                                Number(walletData?.wallet_balance) > 0 && (
                                    <div className=" flex justify-between mt-4">
                                        <div className="text-sm">
                                            <p>استفاده از کیف پول:</p>
                                            <p className=" text-text-gray">
                                                {walletData &&
                                                    walletData?.wallet_balance &&
                                                    walletData?.wallet_balance.toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <Switch
                                            onChange={() =>
                                                setIsWallet(!isWallet)
                                            }
                                            checked={isWallet}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                )}
                            <hr className=" my-4" />
                            <div className=" flex justify-between mt-4">
                                <p className=""> قابل پرداخت:</p>
                                <p>
                                    {isWallet
                                        ? Number(fuckingAmount).toLocaleString()
                                        : Number(
                                              state?.commission + state.total
                                          ).toLocaleString()}{' '}
                                    تومان
                                </p>
                            </div>
                        </div>
                        <div className=" w-full items-center text-center my-4">
                            <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                {activeGateways.map((gw) => (
                                    <img
                                        key={gw.unique_code}
                                        src={gw.img_url}
                                        alt={gw.unique_code}
                                        className={classNames(
                                            'mx-2 cursor-pointer',
                                            selectedCode === gw.unique_code
                                                ? 'border-2 border-green-1 rounded-md'
                                                : 'border-2 border-border-gray rounded-md'
                                        )}
                                        onClick={() => setSelectedCode(gw.unique_code)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className=" bottom-10 absolute w-full">
                        <Footer
                            total={state?.total}
                            commission={state?.commission}
                            ctx_id={data.receivers[0].id}
                            ctx_type={data.receivers[0].type}
                            destination={data.receivers[0].destination}
                            gateway={selectedCode === 'SMN_MPG' ? 5 : 9}
                            selectedGatewayCode={selectedCode}
                            Amount={fuckingAmount}
                            isWallet={isWallet}
                        />
                    </div>
                </>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
